const CODE_VERIFIER_KEY = 'entra.code-verifier'

const toBase64Url = (buffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(buffer)
  let binary = ''
  for (const byte of bytes) {
    binary += String.fromCharCode(byte)
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export const createCodeVerifier = (): string => {
  const bytes = crypto.getRandomValues(new Uint8Array(32))
  return toBase64Url(bytes.buffer)
}

export const createCodeChallenge = async (verifier: string): Promise<string> => {
  const data = new TextEncoder().encode(verifier)
  const digest = await crypto.subtle.digest('SHA-256', data)
  return toBase64Url(digest)
}

export const storeCodeVerifier = (verifier: string): void => {
  sessionStorage.setItem(CODE_VERIFIER_KEY, verifier)
}

export const consumeCodeVerifier = (): string | null => {
  const verifier = sessionStorage.getItem(CODE_VERIFIER_KEY)
  sessionStorage.removeItem(CODE_VERIFIER_KEY)
  return verifier
}
